import { html, slotted } from "@microsoft/fast-element";
import { LoadingButton } from "./loading-button";
/**
 * Generates the template for the {@link @fabric-msft/fabric-web#LoadingButton} component.
 *
 * @public
 * @remarks
 * This template provides the HTML structure and bindings for the `LoadingButton` component.
 * It includes conditional rendering of a spinner based on the `loading` property.
 *
 * @returns {ElementViewTemplate<LoadingButton>} The template for the `LoadingButton` component.
 *
 * @slot - Default slot for the button content.
 * @slot start - Slot for the spinner when the button is loading.
 *
 * @csspart control - The control part of the button.
 */
function loadingButtonTemplate() {
    return html `
    <template
      tabindex="${(x) => { var _a; return (x.disabled ? null : ((_a = x.tabIndex) !== null && _a !== void 0 ? _a : 0)); }}"
      @click="${(x, c) => x.clickHandler(c.event)}"
      @keypress="${(x, c) => x.keypressHandler(c.event)}"
      ?loading="${(x) => x.loading}"
    >
      <slot name="start"></slot>
      <span class="content" part="content">
        <fabric-spinner
          appearance="${(x) => x.appearance == "primary" ? "inverted" : "primary"}"
          size="tiny"
          slot="start"
          ?hidden=${(x) => !x.loading}
        ></fabric-spinner>
        <slot ${slotted("defaultSlottedContent")}></slot>
      </span>
      <slot name="end"></slot>
    </template>
  `;
}
/**
 * The template for the {@link @fabric-msft/fabric-web#LoadingButton} component.
 * @public
 */
export const template = loadingButtonTemplate();
//# sourceMappingURL=loading-button.template.js.map